<template>
  <div class="summary">
    <div class="summary__title" :class="titleClasses">
      {{ ingredientSummaryTitle }}
    </div>

    <div class="summary__color-boxes color-boxes">
      <div
        v-for="ingredient in colorBoxes"
        :key="ingredient.name"
        class="color-boxes__box"
        :style="getColorBoxStyles(ingredient.name)"
      ></div>
    </div>

    <ul class="summary__description description u-typography-helvetica u-text u-text--m">
      <li class="description__item">{{ $t('section.yourIngredients.onlyPharmaGradeText') }}</li>
      <li class="description__item">
        {{ $t('section.yourIngredients.adjustConcentrationText') }}
      </li>
      <li class="description__item">{{ $t('section.yourIngredients.preservativeFreeText') }}</li>
      <li class="description__item">
        {{ $t('section.yourIngredients.keepFullTraceabilityText') }}
      </li>
    </ul>
  </div>
</template>

<script>
import { uniqWith } from 'ramda';
import { mapState } from 'vuex';

import { isIngredientEqual } from '@/models/core/Ingredient';

import { UNICODE_ICONS } from '@/constants/icons';
import { LOCALE } from '@/constants/locale';
import { types } from '@/store/types';

export default {
  name: 'IngredientsSummary',
  arrowRightIcon: UNICODE_ICONS.ARROW_RIGHT,
  props: {
    ingredients: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isVideoPlaying: false
    };
  },
  computed: {
    ...mapState({
      locale: types.state.LOCALE
    }),
    ingredientsCount() {
      return this.ingredients.length;
    },
    ingredientSummaryTitle() {
      return this.ingredientsCount === 1 || this.locale === LOCALE.AR
        ? this.$t('section.yourIngredients.yourActiveIngredientTitle')
        : this.$t('section.yourIngredients.yourActiveIngredientsTitle', [this.ingredientsCount]);
    },
    colorBoxes() {
      return uniqWith(isIngredientEqual)(this.ingredients);
    },
    titleClasses() {
      if (this.$windowWidth.value < 1920) {
        return ['u-typography-helvetica', 'u-text-display', 'u-text-display--s'];
      }

      return ['u-typography-helvetica', 'u-text-display', 'u-text-display--m'];
    }
  },
  methods: {
    getColorBoxStyles(ingredientName) {
      return { backgroundColor: `var(--u-color-${ingredientName})` };
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  &__title {
    margin-bottom: 24px;
  }

  &__color-boxes {
    margin-bottom: 24px;
  }
}

.color-boxes {
  display: flex;

  &__box {
    width: 12px;
    height: 12px;
    border-radius: 1px;

    &:not(:last-child) {
      margin-inline-end: 12px;
    }
  }
}

.description {
  list-style-position: inside;
  margin-inline-start: 8px;

  &__item:not(:last-child) {
    margin-bottom: 16px;
  }
}

@media (min-width: 960px) {
  .summary {
    &__title {
      margin-bottom: 32px;
    }

    &__color-boxes {
      margin-bottom: 32px;
    }
  }

  .description {
    &__item:not(:last-child) {
      margin-bottom: 24px;
    }
  }
}
</style>
